export default __webpack_public_path__ + "static/media/android-device.5b2892cf.png";